var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLikes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1712 10.6665C15.5057 10.6665 12.1385 12.0876 9.68884 14.6683C7.2028 17.2879 5.8335 20.9091 5.8335 24.8652C5.8335 29.0393 7.43048 32.7724 11.0111 36.9694C14.472 41.0262 19.6197 45.2876 25.5799 50.222L25.5909 50.2309C27.6746 51.956 30.0367 53.9117 32.4951 55.9998C34.9682 53.9076 37.334 51.9488 39.4218 50.2211C45.3816 45.2867 50.5288 41.0262 53.9896 36.9694C57.5698 32.7724 59.1668 29.0393 59.1668 24.8652C59.1668 20.9091 57.7975 17.2879 55.3115 14.6683C52.8623 12.0876 49.4946 10.6665 45.8296 10.6665C43.1444 10.6665 40.6791 11.4957 38.5023 13.1308C36.5624 14.5886 33.2924 19.0914 32.5002 20.3808C31.7083 19.0914 28.4383 14.5886 26.498 13.1308C24.3212 11.4957 21.8559 10.6665 19.1712 10.6665Z",
    stroke: "#DD4242",
    strokeWidth: 5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikes);
export default __webpack_public_path__ + "static/media/likes.88e6fcb9.svg";
export { ForwardRef as ReactComponent };